import { Router } from '@okapi/router-react';
import React from 'react';
import { StoreContext } from 'storeon/react';
import { Baseline } from 'common/components';
import { Ceilings } from 'landings/ceilings';
import { RemoteProps } from './widgets-types';

export const CeilingsRemote: React.FC<RemoteProps> = ({ router, store }) => (
  /* @ts-expect-error: Router typecheck error */
  <Router router={router}>
    <Baseline>
      <StoreContext.Provider value={store}>
        <Ceilings />
      </StoreContext.Provider>
    </Baseline>
  </Router>
);
